module.exports = "/packs/images/pages/business_sectors/lac_gym~d5e0bb961bd378884046890047be4f64.jpg";